import type { Language } from '@packages/config';
import type { Audiences } from '../../../interfaces';

export const promotionBannerCacheKey = ({
  language,
  audience,
  platform,
  previewTestDate,
}: {
  language?: Language;
  audience?: Audiences;
  platform?: 'app' | 'web';
  previewTestDate?: string;
}) =>
  ['promotionBannerData', language, audience, platform, previewTestDate].filter(Boolean).join('-');
